<template>
  <el-row>
    <el-row>
      <template v-for="(form, idx) in forms">
        <el-col :span="12" :key="idx">
          <el-form-item
            v-if="idx >= 0 && idx <= 8"
            size="small"
            :prop="form.id"
            :label="form.label"
            :rules="form.rules"
          >
            <el-col :span="12">
              <el-input
                disabled
                v-model="customer[form.id]"
                :type="form.type"
                :placeholder="`Please input ${form.label}`"
              ></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <br />
    <el-row>
      <template v-for="(form, idx) in forms">
        <el-col :span="12" :key="idx">
          <el-form-item
            v-if="idx >= 9 && idx <= 14"
            size="small"
            :prop="form.id"
            :label="form.label"
            :rules="form.rules"
          >
            <el-col :span="12">
              <el-input
                disabled
                v-model="customer[form.id]"
                :type="form.type"
                :placeholder="`Please input ${form.label}`"
              ></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <el-row>
      <template v-for="(form, idx) in forms">
        <el-col :span="24" :key="idx">
          <el-form-item
            v-if="idx === 15"
            size="small"
            :prop="form.id"
            :label="form.label"
            :rules="form.rules"
          >
            <el-col :span="18">
              <el-input
                disabled
                v-model="customer[form.id]"
                :type="form.type"
                :placeholder="`Please input ${form.label}`"
              ></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <el-row>
      <template v-for="(form, idx) in forms">
        <el-col :span="12" :key="idx">
          <el-form-item
            v-if="idx === 16"
            size="small"
            :prop="form.id"
            :label="form.label"
            :rules="form.rules"
          >
            <el-col :span="12">
              <el-input
                disabled
                v-model="customer[form.id]"
                :type="form.type"
                :placeholder="`Please input ${form.label}`"
              ></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <el-row>
      <template v-for="(form, idx) in forms">
        <el-col :span="12" :key="idx">
          <el-form-item
            v-if="idx >= 17 && idx <= 19"
            size="small"
            :prop="form.id"
            :label="form.label"
            :rules="form.rules"
          >
            <el-col :span="12">
              <el-input
                disabled
                v-model="customer[form.id]"
                :type="form.type"
                :placeholder="`Please input ${form.label}`"
              ></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <br />
    <el-row>
      <template v-for="(form, idx) in forms">
        <el-col :span="12" :key="idx">
          <el-form-item
            v-if="idx >= 20 && idx <= 23"
            size="small"
            :prop="form.id"
            :label="form.label"
            :rules="form.rules"
          >
            <el-col :span="12">
              <el-input
                disabled
                v-model="customer[form.id]"
                :type="form.type"
                :placeholder="`Please input ${form.label}`"
              ></el-input>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <br />
    <el-row>
      <template v-for="(form, idx) in forms">
        <el-col :span="12" :key="idx">
          <el-form-item
            v-if="idx === 24"
            size="small"
            :prop="form.id"
            :label="form.label"
            :rules="form.rules"
          >
            <el-col :span="12">
              <el-select
                v-if="form.type == 'select'"
                disabled
                v-model="customer[form.id]"
                :placeholder="`Please select ${form.label}`"
                style="width: 100%"
              >
                <el-option
                  v-for="item in form.data"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
  </el-row>
</template>

<script>
export default {
  props: ["customer"],
  name: "Owner",
  data() {
    return {};
  },
  computed: {
    forms() {
      return [
        {
          type: "text",
          id: "customerNumber",
          label: "Customer Number",
          rules: []
        },
        {
          type: "text",
          id: "oracleCustomerId",
          label: "Oracle Customer Id",
          rules: []
        },
        {
          type: "text",
          id: "customerType",
          label: "Customer Type",
          rules: []
        },
        {
          type: "text",
          id: "customerClassCode",
          label: "Customer Class Code",
          rules: []
        },
        {
          type: "text",
          id: "categoryCode",
          label: "Category Code",
          rules: []
        },
        {
          type: "text",
          id: "orgId",
          label: "Org Id",
          rules: []
        },
        {
          type: "text",
          id: "branch",
          label: "Branch",
          rules: []
        },
        {
          type: "text",
          id: "warehouseId",
          label: "Warehouse Id",
          rules: []
        },
        {
          type: "text",
          id: "primarySalesrepId",
          label: "Primary Sales Rep Id",
          rules: []
        },
        {
          type: "text",
          id: "customerName",
          label: "Name",
          rules: []
        },
        {
          type: "text",
          id: "npwp",
          label: "NPWP",
          rules: []
        },
        {
          type: "text",
          id: "country",
          label: "Country",
          rules: []
        },
        {
          type: "text",
          id: "province",
          label: "Province",
          rules: []
        },
        {
          type: "text",
          id: "city",
          label: "City",
          rules: []
        },
        {
          type: "text",
          id: "state",
          label: "State",
          rules: []
        },
        {
          type: "textarea",
          id: "address",
          label: "Address",
          rules: []
        },
        {
          type: "text",
          id: "postalCode",
          label: "PostalCode",
          rules: []
        },
        {
          type: "text",
          id: "customerNumber",
          label: "Phone Number",
          rules: []
        },
        {
          type: "text",
          id: "oracleDateCreated",
          label: "Oracle Date Created",
          rules: []
        },
        {
          type: "text",
          id: "oracleDateUpdated",
          label: "Oracle Date Update",
          rules: []
        },
        {
          type: "text",
          id: "oracleUserCreated",
          label: "Oracle User Created",
          rules: []
        },
        {
          type: "text",
          id: "oracleUserUpdated",
          label: "Oracle User Update",
          rules: []
        },
        {
          type: "select",
          id: "status",
          label: "Status",
          rules: [],
          data: [
            {
              name: "Active",
              value: "A"
            },
            {
              name: "No Active",
              value: "N"
            }
          ]
        }
      ];
    }
  },
  methods: {}
};
</script>

<style>
.custom-card {
  border: 1px solid #cfcfcf !important;
  background-color: #ffffff;
}
.custom-select .v-input__slot {
  border: 1px solid #ced4da;
  min-height: auto !important;
}

.custom-text-field-owner .v-input__control .v-text-field__details {
  margin: 0px;
}
.custom-text-field-owner .v-input__control .v-input__slot {
  border: 1px solid #ced4da;
  min-height: auto !important;
  margin: 0px;
}
</style>
